// extracted by mini-css-extract-plugin
module.exports = {"container":"newfeed_container__3Wb3q","postCon":"newfeed_postCon__2kEMF"};